var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_604_526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5531 12.7518L10.2211 9.28631C11.0781 8.26949 11.5478 6.98231 11.5472 5.65249C11.5472 2.53576 9.01142 0 5.89468 0C2.77795 0 0.242188 2.53576 0.242188 5.65249C0.242188 8.76923 2.77795 11.305 5.89468 11.305C7.06475 11.305 8.17977 10.9521 9.13307 10.2821L12.4904 13.7739C12.6307 13.9196 12.8195 14 13.0217 14C13.2132 14 13.3948 13.927 13.5327 13.7943C13.6734 13.6586 13.7546 13.4727 13.7584 13.2773C13.7622 13.0818 13.6884 12.8929 13.5531 12.7518ZM5.89468 1.47456C8.19844 1.47456 10.0726 3.34873 10.0726 5.65249C10.0726 7.95625 8.19844 9.83043 5.89468 9.83043C3.59092 9.83043 1.71675 7.95625 1.71675 5.65249C1.71675 3.34873 3.59092 1.47456 5.89468 1.47456Z",
    fill: "#9D9D9D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_604_526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.275be5d4931db0aceaef7c491e3c82cd.svg";
export { ForwardRef as ReactComponent };